import initScrollReveal from "./scripts/scrollReveal";
import { targetElements, defaultProps } from "./data/scrollRevealConfig";

initScrollReveal(targetElements, defaultProps);

const header = document.getElementById("site-header");
const hero = document.getElementById("hero");
const progress = document.getElementById("scroll-progress");
const heroContent = document.querySelector(".hero-content");
const heroMedia = document.querySelector(".hero-media");
const interlude = document.querySelector(".interlude");
const interludeContent = document.querySelector(".interlude-content");
const parallaxNodes = document.querySelectorAll(
  "[data-parallax], [data-parallax-soft]"
);
const serviceItems = document.querySelectorAll(".service-item");
const mediaFrames = document.querySelectorAll(".media-frame");

const prefersReducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)"
).matches;

function clamp(n, min, max) {
  return Math.min(max, Math.max(min, n));
}

function updateHeader() {
  if (!header) return;

  const pastHero = hero
    ? window.scrollY > hero.offsetHeight - header.offsetHeight - 12
    : window.scrollY > 40;

  header.classList.toggle("is-scrolled", pastHero);
  header.classList.toggle("is-solid", pastHero);
}

function updateProgress() {
  if (!progress) return;
  const doc = document.documentElement;
  const max = doc.scrollHeight - window.innerHeight;
  const pct = max > 0 ? (window.scrollY / max) * 100 : 0;
  progress.style.width = `${pct}%`;
}

function updateHeroMotion() {
  if (prefersReducedMotion || !hero) return;

  const rect = hero.getBoundingClientRect();
  if (rect.bottom < 0 || rect.top > window.innerHeight) return;

  const progressY = clamp(-rect.top / Math.max(rect.height, 1), 0, 1);

  if (heroMedia) {
    const img = heroMedia.querySelector("img");
    if (img) {
      img.style.transform = `scale(${1.12 - progressY * 0.04}) translate3d(0, ${
        progressY * 80
      }px, 0)`;
    }
  }

  if (heroContent) {
    heroContent.style.transform = `translate3d(0, ${progressY * -48}px, 0)`;
    heroContent.style.opacity = String(1 - progressY * 0.85);
  }
}

function updateParallax() {
  if (prefersReducedMotion || !parallaxNodes.length) return;

  const viewportH = window.innerHeight;

  parallaxNodes.forEach((node) => {
    const rect = node.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > viewportH) return;

    const p = (viewportH - rect.top) / (viewportH + rect.height);
    const soft = node.hasAttribute("data-parallax-soft");
    const offset = (p - 0.5) * (soft ? 48 : 90);
    const image = node.querySelector("img");
    if (!image) return;

    // Skip hero (handled separately) when nested
    if (node.classList.contains("hero-media")) return;

    image.style.transform = `scale(${soft ? 1.08 : 1.14}) translate3d(0, ${offset}px, 0)`;
  });
}

function updateInterlude() {
  if (prefersReducedMotion || !interlude || !interludeContent) return;

  const rect = interlude.getBoundingClientRect();
  const viewportH = window.innerHeight;
  if (rect.bottom < 0 || rect.top > viewportH) return;

  const p = clamp((viewportH - rect.top) / (viewportH + rect.height), 0, 1);
  const scale = 0.92 + p * 0.12;
  const y = (0.5 - p) * 40;
  interludeContent.style.transform = `translate3d(0, ${y}px, 0) scale(${scale})`;
  interludeContent.style.opacity = String(0.35 + p * 0.65);
}

function updateServiceItems() {
  if (prefersReducedMotion || !serviceItems.length) return;

  const viewportH = window.innerHeight;

  serviceItems.forEach((item, i) => {
    const rect = item.getBoundingClientRect();
    const mid = rect.top + rect.height / 2;
    const dist = (mid - viewportH * 0.55) / viewportH;
    const x = clamp(-dist * 28, -20, 20) * (i % 2 === 0 ? 1 : -0.6);
    const op = clamp(1 - Math.abs(dist) * 0.55, 0.45, 1);
    item.style.transform = `translate3d(${x}px, 0, 0)`;
    item.style.opacity = String(op);
  });
}

function updateMediaClips() {
  if (prefersReducedMotion || !mediaFrames.length) return;

  const viewportH = window.innerHeight;

  mediaFrames.forEach((frame) => {
    const rect = frame.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > viewportH) return;

    const p = clamp((viewportH - rect.top) / (viewportH * 0.9), 0, 1);
    const inset = (1 - p) * 8;
    frame.style.clipPath = `inset(${inset}% ${inset * 0.4}% ${inset}% ${
      inset * 0.4
    }% round 1.6rem)`;
  });
}

let ticking = false;

function onScroll() {
  if (ticking) return;
  ticking = true;

  window.requestAnimationFrame(() => {
    updateHeader();
    updateProgress();
    updateHeroMotion();
    updateParallax();
    updateInterlude();
    updateServiceItems();
    updateMediaClips();
    ticking = false;
  });
}

// Initial paint
updateHeader();
updateProgress();
if (!prefersReducedMotion) {
  updateHeroMotion();
  updateParallax();
  updateInterlude();
  updateServiceItems();
  updateMediaClips();
}

window.addEventListener("scroll", onScroll, { passive: true });
window.addEventListener("resize", onScroll, { passive: true });
